export default {
  geo: [
    {
      z: 0,
      zoom: 1.3,
      map: "china",
      center: [104.354167, 28.708333],
      top: 230,
      // layoutCenter: ['-11%', '75%'], //地图位置
      layoutSize: "280%",
      label: {
        emphasis: {
          show: false,
        },
      },
      itemStyle: {
        borderColor: "rgba(171,192,236,0.65)",
        borderWidth: 0.8,
        areaColor: {
          type: "linear",
          x: 600,
          y: 1200,
          x2: 600,
          y2: 0,
          colorStops: [
            {offset: 0, color: "#669CFF"}, // 0% 处的颜色},
            {offset: 1, color: "#0038A5"}, // 50% 处的颜色},
          ],
          global: true, // 缺省为 false
        },
      },
      emphasis: {
        itemStyle: {
          areaColor: "#0265C2",
          borderColor: "#00BDFC",
        },
      },
      regions: [
        {
          name: "China",
          itemStyle: {
            areaColor: "#36e59b",
          },
        },
        {
          name: "Estonia",
          itemStyle: {
            areaColor: "#ffb000",
          },
        },
      ],
    },

    {
      z: -1,
      zoom: 1.3,
      top: 230,
      map: "china",
      center: [104.354167, 28.708333],
      // layoutCenter: ['-11%', '77%'], //地图位置
      layoutSize: "280%",
      label: {
        emphasis: {
          show: false,
        },
      },
      emphasis: {
        itemStyle: {
          areaColor: "#0320A1",
          borderColor: "#0320A1",
        },
      },
      itemStyle: {
        normal: {
          areaColor: "#0320A1",
          borderColor: "#0320A1",
          borderWidth: 3,
        },
      },
    },
  ],

  series: [
    {
      tooltip: {
        show: false,
      },
      type: "effectScatter",
      coordinateSystem: "geo",
      data: [
        {name: "麓松路", value: [112.877022, 28.232119]},
        // { name: '欣盛路', value: [112.870517, 28.24053] },
        {name: "欣盛路", value: [108.870517, 29.24053]},
        {name: "2", value: [116.870517, 32.24053]},
        {name: "3", value: [108.870517, 36.24053]},
        {name: "3", value: [114.870517, 30.24053]},
        {name: "3", value: [100.870517, 31.24053]},
      ],
      rippleEffect: {
        scale: 10,
        brushType: "stroke",
      },
      showEffectOn: "render",
      itemStyle: {
        normal: {
          color: "#00FFFF",
        },
      },
      symbol: "circle",
      symbolSize: [8, 4],
      zlevel: 1,
    },
    {
      name: "",
      type: "scatter",
      coordinateSystem: "geo",
      data: [
        {name: "麓松路", value: [112.877022, 28.232119]},
        // { name: '欣盛路', value: [112.870517, 28.24053] },
        {name: "欣盛路", value: [108.870517, 29.24053]},
        {name: "2", value: [116.870517, 32.24053]},
        {name: "3", value: [108.870517, 36.24053]},
        {name: "3", value: [114.870517, 30.24053]},
        {name: "3", value: [100.870517, 31.24053]},
      ],
      // series数据内容
      // itemStyle: {
      //   normal: {
      //     color: '#01ff5b',
      //     shadowBlur: 10,
      //   },
      //   // 鼠标悬浮上去的样式
      //   emphasis: {
      //     color: "red",
      //   },
      // },
      // zlevel: 3,
      symbol: `image://${location.protocol}//${location.host}/images/sjdtMark2.png`,
      symbolSize: [27, 27],
      symbolOffset: [0, -20],
      z: 999,
    },
  ],
};
